import { CAST_AI } from '@cast/constants';

export const PERFORMANCE_BANNER_COPY = {
  label: 'Agent installation',
  timelineLabel: 'How it works',
  title: 'Improve performance and efficiency',
  descriptionPrefix:
    'Discovery suggests substantial overprovisioning. Right-sizing could unlock up to',
  descriptionSuffix: 'in recovered spend.',
  installPrefix: 'Install the agent to:',
  unlockFeatures: [
    { label: 'See beyond CPU', icon: 'Eye' as const },
    { label: 'Track reliability', icon: 'CrosshairSimple' as const },
    { label: 'Unlock savings', icon: 'CurrencyDollarSimple' as const },
  ],
  timeline: [
    {
      title: 'Install the agent',
      description:
        'Read-only install in ~2 minutes. Monitoring is free; optimization features start with a 30-day trial',
      icon: 'CloudArrowDown' as const,
    },
    {
      title: 'Unlock deeper visibility',
      description:
        'See workload-level metrics, topology, cost attribution, and recommendations.',
      icon: 'ChartBar' as const,
    },
    {
      title: 'Optimize when ready',
      description:
        'Choose a profile that fits your goals, from Conservative to Aggressive optimization.',
      icon: 'Sparkle' as const,
    },
  ],
  cta: (castAi = CAST_AI) => `Install ${castAi} agent`,
} as const;
